import React, { lazy, useEffect, useState } from "react";
import TopViewNav from "../CommonComponents/TopViewNav";
import ScheduledMetingHeader from "./ScheduledMetingHeader";
import {
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { SummaryAction } from "../../actions/summary";
import { ScheduledAction } from "../../actions/ScheduledMeting";
import { useNavigate } from "react-router-dom";
import ReAssignedModal from "./ReAssignedModal";
import InfoIcon from "@mui/icons-material/Info";
import { Base64 } from "js-base64";
import XLSX from "sheetjs-style";
import LoadingComponent from "../CommonComponents/LoadingComponent";
import { useLocalStorage } from "../../Hooks/Index";
const ImportExcel = lazy(
  () => import("../CustomeForm/ImportExcel/importScheduledMeetingExcel"),
);

function ScheduledMeting() {
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );

  const [selectedSite] = useLocalStorage("selectedSite", null);
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [clientList, setClientList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [ReassignedUserList, setReassignedUserList] = useState([]);
  const [statusId, setStatusId] = useState({});
  const [clientId, setClientId] = useState({});
  //const [filterData, setFilterData] = useState([]);
  const [ReassignedRowId, setReassignedRowId] = useState();
  const [ReassignedUserId, setReassignedUserId] = useState();
  const [configurationName, setConfigurationName] = useState();
  const [NewClientTitle, setNewClientTitle] = React.useState("");
  const [UniqueClients, setUniqueClients] = useState("");
  const [selectOptonCustomer, setSelectOptonCustomer] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [selectOptonSatatus, setSelectOptonSatatus] = React.useState("");
  var base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  console.log(clientId, "clientkkId");
  const [openModalImport, setOpenModalImport] = useState(false);

  const topViewNavData = {
    title: "Scheduled List",
    backPathRoute: "/dashboard",
  };
  const fetchOwnerList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    let userId =
      JSON.parse(localStorage.getItem("data")) &&
      JSON.parse(localStorage.getItem("data")).id;
    const data = {
      hrmsUserId: hrmsID && hrmsID,
      userId: userId && userId,
      siteId: selectedSite ? selectedSite?.id : null,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      // setOwnerList([
      //   { userId: null, name: "ALL", empCode: "all" },
      //   ...res.data,
      // ]);
      setOwnerList(res.data);
    } else {
      setOwnerList([]);
    }
  };

  const fetchScheduledMetingData = () => {
    const schedule = JSON.parse(localStorage.getItem("scheduledMetingList"));
    const data = {
      usersHrmsId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      fromDate:
        schedule !== null && schedule.fromDate ? schedule.fromDate : fromDate,
      toDate:
        schedule !== null && schedule.fromDate ? schedule.fromDate : toDate,
      communicationFollowUpStatus: statusId ? statusId.id : null,
      // assignedToList:
      //   clientId !== null
      //     ? clientId && clientId?.userId
      //       ? [clientId.userId]
      //       : null
      //     : null,
      assignedToList:
        schedule !== null && schedule.UserId
          ? [schedule.UserId]
          : clientId && clientId?.userId
            ? [clientId.userId]
            : null,
      userId: JSON.parse(localStorage.getItem("data")).id,
    };
    setLoading(true);
    ScheduledAction.fetchScheduledMeting(data).then((response) => {
      if (response !== null) {
        if (response.responseCode === 204) {
          alert(response.responseDescription);
        }
        setClientList(response.data);
        setStatusData(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.log("error");
      }
    });
  };

  const ridairectopen = (data) => {
    if (data.communicationFollowUpStatus == "COMPLETED") {
      localStorage.setItem("ScheduledData", JSON.stringify(data));
      window.open("/outdoorduties", "_self");
    }
  };

  const openReAssignedModal = (data) => {
    setReassignedRowId(data.id);
    const reAssignedList =
      ownerList &&
      ownerList.length > 0 &&
      ownerList.filter((val) => val.name !== data.assignedToUser.name);
    console.log(reAssignedList, "reAssignedList");
    setReassignedUserList(reAssignedList);
    setOpenModal(true);
  };
  const updateUserHandler = () => {
    if (ReassignedUserId == undefined || ReassignedUserId == "") {
      alert("plz Select User");
      return false;
    }
    const data = {
      id: ReassignedRowId,
      reAssignedToId: ReassignedUserId.userId,
      updatedBy: JSON.parse(localStorage.getItem("data")).id,
    };
    ScheduledAction.fetchReassinedUser(data).then((response) => {
      if (response !== null) {
        fetchScheduledMetingData();
        alert(response.responseDescription);
        setOpenModal(false);
      } else {
        console.log("error");
      }
    });
  };

  const fetchconfigurationdetailsheader = () => {
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const siteId = selectedSite ? selectedSite?.id : null;
    ScheduledAction.configurationdetails({ hrmsCompanyId, siteId }).then(
      (response) => {
        if (response !== null) {
          const showheader =
            response &&
            response.data &&
            response.data.filter(
              (val) =>
                val &&
                val.configurationName === "IS_MEETING_SCHEDULED_WITH_TIME",
            );
          setConfigurationName(
            showheader &&
              showheader !== undefined &&
              showheader.length > 0 &&
              showheader[0].configurationName,
          );

          //localStorage.setItem("configurationdetailsheader", response.data)
        }
      },
    );
  };

  const ridirectFetchData = () => {
    if (JSON.parse(localStorage.getItem("scheduledMetingList"))) {
      const schedule = JSON.parse(localStorage.getItem("scheduledMetingList"));
      setFromDate(
        moment(
          schedule
            ? schedule.fromDate
            : moment(moment().startOf("day")).format("YYYY-MM-DD"),
        ).format("YYYY-MM-DD"),
      );
      setToDate(
        moment(
          schedule
            ? schedule.fromDate
            : moment(moment().endOf("day")).format("YYYY-MM-DD"),
        ).format("YYYY-MM-DD"),
      );
      //setClientId({userId:schedule.UserId})
    }
  };
  const fetchHederTitle = () => {
    const Templatedata = JSON.parse(localStorage.getItem("Templatedata"));
    const NewClient =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "client") {
          return setNewClientTitle(val.displayName);
        }
      });
    const NewClientCount =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Unique Clients") {
          return setUniqueClients(val.displayName);
        }
      });
    const SelectClientOwner =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Select Client Owner") {
          return setSelectOptonCustomer(val.displayName);
        }
      });
    const SelectClientsataus =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Client Status") {
          return setSelectOptonSatatus(val.displayName);
        }
      });
  };

  const showFilteredData = () => {
    fetchScheduledMetingData();
  };

  const OpenModalHandler = () => {
    setOpenModalImport(true);
  };
  const closeExcelImportModal = () => {
    setOpenModalImport(false);
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("scheduledMetingList"))) {
      ridirectFetchData();
    }
  }, [JSON.parse(localStorage.getItem("scheduledMetingList")), selectedSite]);

  useEffect(() => {
    fetchHederTitle();
    fetchOwnerList();
    fetchScheduledMetingData();
    fetchconfigurationdetailsheader();
    localStorage.removeItem("scheduledMetingList");
  }, [selectedSite]);

  function exportToExcel(type, fn, dl) {
    const worksheet = XLSX.utils.table_to_sheet(
      document.getElementById("FlowUpTable"),
    );

    const colName = (n) => {
      let s = "";
      while (n >= 0) {
        s = String.fromCharCode((n % 26) + 65) + s;
        n = Math.floor(n / 26) - 1;
      }
      return s;
    };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = colName(col) + (row + 1);
        const cell = worksheet[cellAddress];
        if (!cell) continue;

        // Base style for all cells
        cell.s = {
          font: {
            name: "Liberation Serif",
            sz: 10,
            bold: row === 0, // Only first row bold
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `FollowUp.xlsx`, {
      compression: true,
    });
  }

  const exportHandler = () => {
    // setTimeout(() => {
    document.getElementById("clientExport").click();
    // exportToExcel();
    // }, 500);
  };

  return (
    <main className="contents__root">
      <ImportExcel
        openModal={openModalImport}
        closeExcelImportModal={closeExcelImportModal}
        fetchScheduledMetingData={fetchScheduledMetingData}
      />
      <LoadingComponent isLoading={loading} />
      <Grid container alignItems={"center"}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
              mb: 0.5,
            }}
          >
            <TopViewNav topViewNavData={topViewNavData} inlineDisplay={true} />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              {localData?.isScheduleMeetingBulkImportEnable ? (
                <div>
                  <Box>
                    <div className="field_box">
                      <div
                        className="field_box_btn1"
                        onClick={OpenModalHandler}
                        style={{
                          cursor: "pointer",
                          padding: "8px",
                        }}
                      >
                        Import Excel
                      </div>
                    </div>
                  </Box>
                </div>
              ) : (
                ""
              )}
            </div>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            className="top_fields"
            display={"flex"}
            sx={{ justifyContent: "flex-end" }}
            gap="5px"
          >
            <div
              className="fieldBox"
              style={{
                backgroundColor: "rgb(61 61 122)",
                color: "#fff",
              }}
            >
              <span className="count">Total</span>
              <span className="count">
                {statusData ? statusData.totalCommFollowUp : 0}
              </span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "#32a472",
                color: "#fff",
              }}
            >
              <span className="count">Total Completed </span>
              <span className="count">
                {statusData ? statusData.totalCompletedCommFollowUp : 0}
              </span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "rgb(212 199 43)",
                color: "#fff",
              }}
            >
              <span className="count">Total Scheduled </span>
              <span className="count">
                {statusData ? statusData.totalScheduledCommFollowUp : 0}
              </span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "#2bd4b5",
                color: "#fff",
              }}
            >
              <span className="count">Total Rescheduled </span>
              <span className="count">
                {statusData ? statusData.totalRescheduledCommFollowUp : 0}
              </span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "#e94b61",
                color: "#fff",
              }}
            >
              <span className="count">Missed </span>
              <span className="count">
                {statusData ? statusData.totalMissedCommFollowUp : 0}
              </span>
            </div>
          </Box>
        </Grid>
      </Grid>
      {openModal && (
        <Grid>
          <ReAssignedModal
            title={"Re Assigned To User"}
            setOpenModal={setOpenModal}
            openModal={openModal}
            ReassignedUserList={ReassignedUserList}
            updateUserHandler={updateUserHandler}
            setReassignedUserId={setReassignedUserId}
          />
        </Grid>
      )}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ScheduledMetingHeader
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            ownerList={ownerList}
            statusId={statusId}
            setStatusId={setStatusId}
            clientId={clientId}
            setClientId={setClientId}
            showFilteredData={showFilteredData}
            statusData={statusData}
            exportHandler={exportHandler}
            selectOptonCustomer={selectOptonCustomer}
          />

          <TableContainer component={Paper}>
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
              id="FlowUpTable"
              sx={{
                minWidth: 1200,

                "& tbody td": {
                  border: "0.5px solid #d0d7de",
                },

                // First column
                "& th:first-of-type, & td:first-of-type": {
                  position: "sticky",
                  left: 0,
                  zIndex: 2,
                  // backgroundColor: "#fff",
                },

                "td:first-of-type": {
                  backgroundColor: "#fff",
                },

                // Header cells
                "& thead th": {
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  backgroundColor: "rgb(32 80 130)",
                  border: "none",
                },

                // Top-left cell needs highest z-index
                "& thead th:first-of-type": {
                  left: 0,
                  zIndex: 4,
                },
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "rgb(32 80 130)",
                    color: "#fff",
                  }}
                  key={1}
                >
                  <TableCell style={{ color: "#fff" }} align="center">
                    S.No.
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    {localData?.isClientNameChanged
                      ? (
                          `${
                            NewClientTitle !== "" ? NewClientTitle : "Client"
                          }  Name` + ""
                        )?.replace(
                          /client/gi,
                          localData?.changedClientFieldName || "Client",
                        )
                      : `${
                          NewClientTitle !== "" ? NewClientTitle : "Client"
                        }  Name`}
                  </TableCell>

                  <TableCell style={{ color: "#fff" }} align="center">
                    Scheduled Date
                  </TableCell>
                  {/* {configurationName !== undefined && configurationName == "IS_MEETING_SCHEDULED_WITH_TIME" && (
                    <>

                      <TableCell style={{ color: "#fff" }} align="center">
                        Scheduled Start Date Time
                      </TableCell>
                      <TableCell style={{ color: "#fff" }} align="center">
                        Scheduled End Date Time
                      </TableCell>
                    </>
                  )} */}
                  <TableCell style={{ color: "#fff" }} align="center">
                    ReScheduled Date
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Scheduled By
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Re-Assigned By
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Re-Assigned To
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Last Assigned To
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Last Meeting Date
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", maxWidth: "200px" }}
                    align="center"
                  >
                    {localData?.isClientNameChanged
                      ? (
                          `${
                            NewClientTitle !== "" ? NewClientTitle : "Client"
                          }  Owner` + ""
                        )?.replace(
                          /client/gi,
                          localData?.changedClientFieldName || "Client",
                        )
                      : `${
                          NewClientTitle !== "" ? NewClientTitle : "Client"
                        }  Owner`}
                  </TableCell>
                  <TableCell style={{ color: "#fff" }} align="center">
                    Branch
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">
                    Remark
                  </TableCell>
                  {/* {configurationName !== undefined &&
                    (configurationName === "IS_MEETING_SCHEDULED_WITH_TIME") || true &&  ( */}
                  {true && (
                    <>
                      <TableCell style={{ color: "#fff" }} align="center">
                        Meeting Completion Status
                      </TableCell>
                    </>
                  )}
                  <TableCell style={{ color: "#fff" }} align="center">
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {clientList &&
                  clientList.communicationFollowUpDTOList &&
                  clientList.communicationFollowUpDTOList.map((val, ind) => {
                    // const n =
                    //   val.conclusion.includes("\n") &&
                    //   val.conclusion.replace(/\n/, "");
                    // const copy = val.conclusion.slice();
                    // const t = val.conclusion.slice(
                    //   0,
                    //   val.conclusion.length - 3
                    // );
                    // const isBase64Encdoed = base64regex.test(
                    //   t + "=="
                    // );
                    return (
                      <>
                        <TableRow
                          maxHeight={100}
                          minHeight={70}
                          style={{
                            background:
                              val.communicationFollowUpStatus === "SCHEDULED"
                                ? "rgb(212, 199, 43)"
                                : val.communicationFollowUpStatus ===
                                    "RESCHEDULED"
                                  ? "rgb(43, 212, 181)"
                                  : val.communicationFollowUpStatus ===
                                      "COMPLETED"
                                    ? "rgb(50, 164, 114)"
                                    : val.communicationFollowUpStatus ===
                                        "MISSED"
                                      ? "rgb(233, 75, 97)"
                                      : "#fff",
                            height: "50px",
                          }}
                        >
                          <TableCell
                            style={{
                              placeContent: "center",
                            }}
                          >
                            {ind + 1}
                          </TableCell>
                          <TableCell align="center">
                            {val && val.client && val.client.name
                              ? val.client.name
                              : "NA"}
                          </TableCell>
                          <TableCell sx={{ width: "160px" }}>
                            {val && val.scheduledAt
                              ? moment(val.scheduledAt).format("DD/MM/YYYY")
                              : "NA"}
                            <p>
                              {" "}
                              Start:
                              {val.lastMeetingScheduledStartDateTime &&
                              val.lastMeetingScheduledStartDateTime !== null
                                ? moment(
                                    val.lastMeetingScheduledStartDateTime,
                                  ).format("hh:mm A")
                                : "NA"}{" "}
                            </p>
                            <p>
                              End:{" "}
                              {val.lastMeetingScheduledEndDateTime &&
                              val.lastMeetingScheduledEndDateTime !== null
                                ? moment(
                                    val.lastMeetingScheduledEndDateTime,
                                  ).format("hh:mm A")
                                : "NA"}
                            </p>
                          </TableCell>
                          {/* {configurationName !== undefined && configurationName == "IS_MEETING_SCHEDULED_WITH_TIME" && (
                            <>
                              <TableCell sx={{ width: "140px" }}>
                                {val.meetingScheduledStartDateTime && val.meetingScheduledStartDateTime !== null ? moment(val.meetingScheduledStartDateTime).format("DD/MM/YYYY hh:mm A") : "NA"}
                              </TableCell>
                              <TableCell sx={{ width: "140px" }}>
                                {val.meetingScheduledEndDateTime && val.meetingScheduledEndDateTime !== null ? moment(val.meetingScheduledEndDateTime).format("DD/MM/YYYY hh:mm A") : "NA"}
                              </TableCell>
                            </>)} */}
                          <TableCell sx={{ width: "140px" }}>
                            {val && val.reScheduledDate !== null
                              ? moment(val.reScheduledDate).format("DD/MM/YYYY")
                              : "NA"}
                            {val.reScheduledDate !== null ? (
                              <>
                                <p>
                                  {" "}
                                  Start:
                                  {val.meetingScheduledStartDateTime &&
                                  val.meetingScheduledStartDateTime !== null
                                    ? moment(
                                        val.meetingScheduledStartDateTime,
                                      ).format(" hh:mm A")
                                    : "NA"}{" "}
                                </p>
                                <p>
                                  End:{" "}
                                  {val.meetingScheduledEndDateTime &&
                                  val.meetingScheduledEndDateTime !== null
                                    ? moment(
                                        val.meetingScheduledEndDateTime,
                                      ).format("hh:mm A")
                                    : "NA"}
                                </p>{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {`${
                              val && val.cretedByUser && val.cretedByUser.name
                            } ${
                              val.cretedByUser && val.cretedByUser.empCode
                                ? `(${val.cretedByUser.empCode})`
                                : ""
                            }`}
                          </TableCell>
                          <TableCell>
                            {val && val.lastAssignedToUser !== null ? (
                              <>
                                {`${
                                  val.reAssignedByUser &&
                                  val.reAssignedByUser.name !== null
                                    ? val.reAssignedByUser.name
                                    : "NA"
                                } ${
                                  val.reAssignedByUser &&
                                  val.reAssignedByUser.empCode !== null
                                    ? `(${val.reAssignedByUser.empCode})`
                                    : ""
                                }`}{" "}
                              </>
                            ) : (
                              "NA"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {/* {val.reScheduledDate !== null?} */}

                            <span style={{ display: "flex" }}>
                              {`${
                                val &&
                                val.assignedToUser &&
                                val.assignedToUser.name
                                  ? val.assignedToUser.name
                                  : "NA"
                              } ${
                                val &&
                                val.assignedToUser &&
                                val.assignedToUser.empCode
                                  ? `(${val.assignedToUser.empCode})`
                                  : ""
                              }`}
                              {val.isReAssignedButtonShow == true ? (
                                // <Button variant="contained" onClick={() => openReAssignedModal(val)}>Reassigned</Button>

                                <Tooltip title="Reassigned">
                                  <IconButton
                                    onClick={() => openReAssignedModal(val)}
                                  >
                                    <InfoIcon />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                ""
                              )}
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            {`${
                              val.lastAssignedToUser &&
                              val.lastAssignedToUser.name
                                ? val.lastAssignedToUser.name
                                : "NA"
                            } ${
                              val.lastAssignedToUser &&
                              val.lastAssignedToUser.empCode
                                ? `(${val.lastAssignedToUser.empCode})`
                                : ""
                            }`}
                          </TableCell>
                          <TableCell sx={{ width: "140px" }}>
                            {val.client && val.client.lastMeetingDate
                              ? moment(val.client.lastMeetingDate).format(
                                  "DD/MM/YYYY hh:mm A",
                                )
                              : "NA"}
                          </TableCell>

                          <TableCell align="center">
                            {`${val.client && val.client.clientOwnerName} ${
                              val.client && val.client.clientOwnerEmpCode
                                ? `(${val.client.clientOwnerEmpCode})`
                                : ""
                            }`}
                          </TableCell>

                          <TableCell align="center" sx={{ width: "350px" }}>
                            {val && val.branch && val.branch !== null
                              ? val.branch.name
                              : "NA"}
                          </TableCell>

                          <TableCell
                            align="center"
                            style={{
                              maxWidth: "250px",
                              flexWrap: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            <span style={{ width: "350px" }}>
                              {val.updatedRemarks == null
                                ? val.remarks || "NA"
                                : val.updatedRemarks &&
                                    val.updatedRemarks !== null
                                  ? val.updatedRemarks
                                  : "NA"}

                              {/* {val && val.remarks && val.remarks.includes("\n") && base64regex.test(val.remarks.replace(/\n/, "")) ? Base64.decode(val.updatedRemarks == null
                                ? val.remarks
                                : val.updatedRemarks && val.updatedRemarks !== null ? val.updatedRemarks : "NA") : val.updatedRemarks == null
                                ? val.remarks
                                : val.updatedRemarks && val.updatedRemarks !== null ? val.updatedRemarks : "NA"} */}
                            </span>
                          </TableCell>
                          {/* {configurationName !== undefined &&
                            configurationName ==
                            "IS_MEETING_SCHEDULED_WITH_TIME" && ( */}
                          {true && (
                            <>
                              <TableCell align="center">
                                {val.commCompletionStatus &&
                                  val.commCompletionStatus}
                              </TableCell>
                            </>
                          )}

                          <TableCell
                            align="center"
                            style={{
                              cursor: "pointer",
                              color:
                                val.communicationFollowUpStatus == "COMPLETED"
                                  ? "blue"
                                  : "",
                            }}
                            onClick={() => ridairectopen(val)}
                          >
                            {val.communicationFollowUpStatus &&
                              val.communicationFollowUpStatus}
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </main>
  );
}

export default ScheduledMeting;
